<script setup lang="ts">
import type { SelectionItem } from '@models/selectionItem.ts';
import { computed } from 'vue';
import SelectionItemRemovedActions from '@organisms/offer/selection-items/components/SelectionItemRemovedActions.vue';
import { trans } from '@elements/translation';
import SelectionItemDeleteButton from '@organisms/offer/selection-items/components/SelectionItemDeleteButton.vue';
import SelectionItemInboxLink from '@organisms/offer/selection-items/components/SelectionItemInboxLink.vue';
import ContactOfferButton from '@components/ContactOfferButton.vue';
import IconCheck from '@icons/ph_check.svg';
import Icon from '@components/Icon.vue';

const props = defineProps<{ selectionItem: SelectionItem }>();

const isOfferContacted = computed<boolean>(() => !!props.selectionItem.deal);

const hashIds = computed<string[]>(() => props.selectionItem.offers.map((offer) => offer.hash_id));
</script>

<template>
  <div class="selection-item-actions">
    <template v-if="!selectionItem.is_removed">
      <SelectionItemDeleteButton
        :selection-item-id="selectionItem.id"
        class="selection-item-action selection-item-action--remove"
      />

      <template v-if="!selectionItem.is_all_offers_rented">
        <SelectionItemInboxLink
          v-if="isOfferContacted"
          :deal="selectionItem.deal"
          class="selection-item-action selection-item-action--inbox"
        />

        <ContactOfferButton
          v-else
          :hash-ids="hashIds"
          :proposal-id="selectionItem.proposal?.id"
          class="btn-link selection-item-action selection-item-action--contact"
        >
          <Icon
            :svg="IconCheck"
            fill="green"
            width="24"
            height="24"
          />

          <span>
            {{ trans('selection_item.contact.link') }}
          </span>
        </ContactOfferButton>
      </template>
    </template>

    <SelectionItemRemovedActions
      v-else
      class="selection-item-actions__removed"
      :selection-item="selectionItem"
    />
  </div>
</template>

<style scoped lang="scss">
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.selection-item-actions {
  padding: rem(16);
  display: flex;
  justify-content: center;
  gap: rem(8);

  &__removed {
    flex: 1;
  }
}
</style>
